import { useTheme } from '@/hooks/useTheme'
import type { ReactNode } from 'react'

/**
 * Mounts the app-level theme hook once at the root of the React tree.
 *
 * Responsibilities:
 *   - Forces early construction of useTheme's module-singleton ThemeStore,
 *     which applies the `.dark` / `.light` class to `<html>` on construction
 *     and keeps it in sync with localStorage / system preference / cross-tab
 *     storage events from then on.
 *   - Serves as the single source of truth; all other consumers (e.g. sonner
 *     Toaster, the header ThemeToggle, canvases) call `useTheme` directly and
 *     subscribe to the SAME store, staying in sync without a React context —
 *     a setTheme() from any one of them is seen by all others immediately.
 *
 * FOUC is handled separately by the inline <script> in index.html which
 * applies the class synchronously before React paints. See ADR-055.
 */
export function ThemeProvider({ children }: { children: ReactNode }) {
  useTheme() // side-effects only
  return <>{children}</>
}
